import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ListFormulas from './ListFormulas'
import ShowFormulaPage from './ShowFormulaPage'
import NewFormulaPage from './NewFormulaPage'
import EditFormulaPage from './EditFormulaPage'

const Formulas = ({match}) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListFormulas} />
    <Route exact path={match.url + '/new'} component={NewFormulaPage} />
    <Route path={match.url + '/:id/edit'} component={EditFormulaPage} />
    <Route path={match.url + '/:id'} component={ShowFormulaPage} />
  </Switch>
)

export default Formulas



// WEBPACK FOOTER //
// ./src/components/Formulas/Formulas.jsx